import React from "react";
import FirmList from "./FirmList";
import FirmBanner from "./FirmBanner";
import FundingFirmHelmet from "../Helmets/FundingFirmHelmet";


export default function Index() {
  return (
    <div className="container">
      <FundingFirmHelmet />
      <FirmBanner />
      <FirmList />
      
    </div>
  );
}
